import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
const Paytm = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src=''/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sort an array of 0s, 1s and 2s</p>
      <NavLink to='/category/Paytm Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

  
  <div class="card 1">
    <div class="card_image">
      <img src='' />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse words in a given string</p>
        <NavLink to='/category/Paytm Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src='' /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse a linked list</p>
      <NavLink to='/category/Paytm Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src='' />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse a Linked List in groups of given size</p>
      <NavLink to='/category/Paytm Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src='' />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Max Sum without Adjacents</p>
        <NavLink to='/category/Paytm Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src='' />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Mirror Tree</p>
      <NavLink to='/category/Paytm Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
   
  
    <div class="card 4">
    <div class="card_image">
      <img src='' />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Flattening a Linked List</p>
      <NavLink to='/category/Paytm Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src='' />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Check for Balanced Tree</p>
        <NavLink to='/category/Paytm Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src='' /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find the number of islands</p>
      <NavLink to='/category/Paytm Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src='' />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Coin Change</p>
      <NavLink to='/category/Paytm Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src='' />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Count frequencies of all elements in array in O(1) extra space and O(n) time</p>
        <NavLink to='/category/Paytm Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src='' />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Convert array into Zig-Zag fashion</p>
      <NavLink to='/category/Paytm Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
    <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
    <div class="card 3">
      <div class="card_image"> <img src='' /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Find the row with maximum number of 1s</p>
        <NavLink to='/category/Paytm Interview question 13'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
      </div>
    </div>
    <div class="card 3">
      <div class="card_image"> <img src='' /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Maximum Rectangular Area in a Histogram</p>
        <NavLink to='/category/Paytm Interview question 14'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
          </div>
      </div>
    </div>
    </div>
       </div>  

    )
}

export default Paytm
